import { call, put, select } from 'redux-saga/effects';
import { iActionGetAll } from '~/domain/interfaces/redux/appointmentPriorities/getAll';
import { GetAllAppointmentPriorities } from '~/domain/usecases/appointmentPriorities/remote/GetAllAppointmentPriorities';
import { makeRemoteGetAllAppointmentPriorities } from '~/main/factories/usecases/appointmentPriorities/GetAllAppointmentPriorities';
import {
  getAllSuccess,
  getAllFailed,
} from '~/data/store/reducer/appointmentPriorities/actions/getAll';

export function* onGetAll(action: iActionGetAll) {
  const remoteGetAllAppointment = makeRemoteGetAllAppointmentPriorities();

  try {
    const response: GetAllAppointmentPriorities.Model = yield call(
      remoteGetAllAppointment.list,
      action.payload,
    );

    yield put(getAllSuccess(response));
  } catch (e) {
    yield put(getAllFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllFailed() {}
